import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import { colors, spacing } from '@bridebook/ui/src/themes/variables';

interface IStyles {
  itemWrap: FelaCSS;
  iconWrap: FelaCSS;
  text: FelaCSS;
}

const styles: IStyles = {
  itemWrap: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 2,
    maxWidth: '100%',
    wordBreak: 'break-word',

    minWidthDesktop: {
      paddingRight: 'unset',
    },
  },

  iconWrap: {
    justifyContent: 'center',
    marginRight: spacing[3],
    height: '16px',
  },

  text: {
    fontDefault: 14,
    lineHeight: '25px',
    color: colors.space75,
  },
};

export default styles;
